import { EmptyState } from '@components/empty-state';
import { IconMarketplace } from '@components/icons/marketplace';
import { useScopedTranslate } from '@locale/translate';

import { TabContentWrapper } from './common';

export const AppsTab = () => {
  const { t } = useScopedTranslate(locale);

  return (
    <TabContentWrapper>
      <EmptyState
        icon={<IconMarketplace />}
        header={t('title')}
        content={t('subtitle')}
        skipMargin
      />
    </TabContentWrapper>
  );
};

const locale = {
  en: {
    title: 'App marketplace',
    subtitle:
      'Your integrations, one marketplace\n\nDiscover and connect tools that power your workflows — all in one place\n\nComing soon 🎉',
  },
};
